import React, { memo, useMemo } from "react";
import { FilterOption } from "..";
import styles from "./styles.module.scss";

interface FilterButtonsListProps {
    filters: FilterOption[];
    activeSlugs: string[];
    onToggle: (slug: string) => void;
}

function FilterButtonsList({
    filters,
    activeSlugs,
    onToggle,
}: FilterButtonsListProps) {
    const activeSlugsSet = useMemo(() => new Set(activeSlugs), [activeSlugs]);
    return (
        <div className={styles.filterButtons}>
            {filters?.map((filter) => {
                if (!filter?.slug) return null;
                const isActive = activeSlugsSet.has(filter.slug);

                return (
                    <button
                        key={filter.slug}
                        type="button"
                        className={`${styles.filterButton} ${
                            isActive ? styles.active : ""
                        }`}
                        onClick={() => onToggle(filter.slug)}
                        aria-pressed={isActive}
                    >
                        {filter?.icon && (
                            <img
                                src={filter?.icon}
                                alt={filter?.title ?? ""}
                                className={styles.filterButtonIcon}
                            />
                        )}
                        <span className={styles.filterButtonText}>
                            {filter?.title}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}

export default memo(FilterButtonsList);
